var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreece(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0342C24.8366 32.0342 32 24.8707 32 16.0342C32 7.19762 24.8366 0.0341797 16 0.0341797C7.16344 0.0341797 0 7.19762 0 16.0342C0 24.8707 7.16344 32.0342 16 32.0342Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.8606H31.4488C31.0476 10.3723 30.4379 8.96969 29.6516 7.68668H16V11.8606Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0402 28.5555H25.9598C27.42 27.3925 28.6722 25.9799 29.6516 24.3816H2.34839C3.32783 25.9798 4.58008 27.3925 6.0402 28.5555V28.5555Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5652 3.90494C4.30733 4.98812 3.21989 6.26369 2.34839 7.68593H5.5652V3.90494Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.0344C16 14.4046 16 13.0407 16 11.8604H9.73913V16.0344H5.56519V11.8604H0.551188C0.1925 13.1913 0 14.5902 0 16.0344C0 17.4786 0.1925 18.8774 0.551188 20.2083H31.4489C31.8075 18.8774 32 17.4786 32 16.0344H16Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 0.0341797C13.7783 0.0341797 11.6624 0.487492 9.73926 1.30593V7.68637H16.0001C16.0001 6.22937 16.0001 4.99018 16.0001 3.51243H25.9599C23.2268 1.33568 19.7657 0.0341797 16.0001 0.0341797V0.0341797Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreece);
export default __webpack_public_path__ + "static/media/greece.7b5fa72c.svg";
export { ForwardRef as ReactComponent };